import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { SecretValue } from "client/Api/Apps/common";

export type EnvironmentTopDeskConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
	isDefault: false;
};

export type DefaultTopDeskConnectionListItemModel = {
	name: string;
	serverUrl: string;
	isDefault: true;
};

export type TopDeskConnectionListItemModel =
	| EnvironmentTopDeskConnectionListItemModel
	| DefaultTopDeskConnectionListItemModel;

export type TopDeskConnectionModel = {
	id: number;
	name: string;
	serverUrl: string;
	username: string;
};

export type TopDeskConnectionSaveModel = {
	name: string;
	serverUrl: string;
	username: string;
	password: SecretValue;
};

export function list(
	signal?: AbortSignal
): Promise<readonly TopDeskConnectionListItemModel[]> {
	return httpClient.get<readonly TopDeskConnectionListItemModel[]>(
		"UiApi/TopDeskConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal: AbortSignal
): Promise<TopDeskConnectionModel> {
	return httpClient.get<TopDeskConnectionModel>(
		`UiApi/TopDeskConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export function create(model: TopDeskConnectionSaveModel): Promise<{id: number;}> {
	return httpClient.post<{id: number;}>("UiApi/TopDeskConfiguration", model);
}

export function update(id: number, model: TopDeskConnectionSaveModel): Promise<void> {
	return httpClient.put<void>(`UiApi/TopDeskConfiguration/${id}`, model);
}

export function deleteMultiple(
	ids: readonly number[],
	signal?: AbortSignal
): Promise<void> {
	return httpClient.delete<void>(
		"UiApi/TopDeskConfiguration",
		ids,
		{ signal }
	);
}
